import React, { useState } from "react";
import SearchBar from "./Components/SearchBar";
import MovieList from "./Components/MovieList";
import FavouriteMovies from "./Components/FavouriteMovies";
import MoviesData from "./Components/MoviesData";
import "./App.css";

function App() {

  const [searchQuery, setSearchQuery] = useState("");
  const [favourites, setFavourites] = useState([]);
  const [darkMode, setDarkMode] = useState(false);

  // 🔍 FILTER FROM STATIC DATA
  const filteredMovies = MoviesData.filter((movie) =>
    movie.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // ⭐ TOGGLE FAVOURITE (FIXED)
  const toggleFavourite = (movie) => {
    setFavourites((prevFavs) => {
      const exists = prevFavs.some((fav) => fav.id === movie.id);

      if (exists) {
        return prevFavs.filter((fav) => fav.id !== movie.id);
      } else {
        return [...prevFavs, movie];
      }
    });
  };

  return (
  <div className={darkMode ? "container dark" : "container"}>

    {/* Header */}
    <div className="header">
      <div>
        <h1 className="title">Movie Explorer</h1>
        <p className="subtitle">Start typing to search movies</p>
      </div>

      <button
        className="theme-toggle"
        onClick={() => setDarkMode(!darkMode)}
      >
        🌙 Toggle theme
      </button>
    </div>

    {/* Search */}
    <SearchBar
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
    />

    {/* Sections */}
    <div className="content">

      {/* LEFT */}
      <div className="left">

        <h3>All Movies</h3>
        <h2>Matching Movies</h2>

        <MovieList
          movies={filteredMovies}
          toggleFavourite={toggleFavourite}
          favourites={favourites}
          searchQuery={searchQuery}
        />

      </div>

      {/* RIGHT */}
      <div className="right">

        <h2>Favorite Movies</h2>

        <FavouriteMovies
          favourites={favourites}
          toggleFavourite={toggleFavourite}
        />

      </div>

    </div>

  </div>
);
}

export default App;